import React from 'react';

var map = require('../../../assets/images/location-small.png');

export default function MapTooltip(props) {
	// console.log('MapTooltip', props);
	return (
		<div className="border border-gray-500 w-72 rounded">
			<div className="py-2 px-3 font-semi-bold text-sm">
				<div>670323 Kiapoko Pl, Waialua, HI 96791</div>
			</div>
			<div>
				<img className="rounded-b" src={map} alt="property-map" />
			</div>
		</div>
	);
}
